@if (currentPage().data.length > 0) {
  <div class="share-classes-card-container">
    <div class="column-headings">
      <div class="shares-issued-heading">ISSUED</div>
    </div>
    <div class="cards">
      @for (shareClass of currentPage().data; track shareClass) {
        <button type="button" (click)="rowClicked.emit(shareClass)" (keydown.enter)="rowClicked.emit(shareClass)"
          class="card"
          >
          <div class="left-elements">
            <div class="share-class">{{shareClass.shareClass}}</div>
            <div class="lower-elements">
              <div class="currency-code">{{shareClass.currencyCode}}</div>
              <div class="par-value">PAR VALUE {{shareClass.nominalValue.displayValue}}</div>
            </div>
          </div>
          <div class="right-elements">
            <div class="shares-issued">{{shareClass.sharesIssued.displayValue}}</div>
          </div>
        </button>
      }
    </div>
  </div>
}
